/* eslint-disable react/prop-types */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { Form, Input, Tooltip, Icon, Button, Row, Col, Select } from 'antd';
import { Segment } from '@fxtr/i18n';
import config from '$config';
import { AddressSelectorWithGooglePlaces } from '$app/shared/components/AddressSelectorWithGooglePlaces';
import If from '../../components/Helpers/If';
import { FormFooter, ClosedButton } from './styled';

const FormItem = Form.Item;

const { Option } = Select;

class ZoneEditor extends Component {
  static defaultProps = {
    onSuccess: () => Promise.resolve(),
    onClose: null,
    onReset: null,
    isLoading: false,
  };

  state = {
    status: null,
    address: {},
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        values.latitude = this.state.address.latitude;
        values.longitude = this.state.address.longitude;
        values.metadata = { status: values.status };
        delete values.status;
        this.props.onSuccess(values);
      }
    });
  };

  componentDidMount() {
    if (this.props.editing)
      this.props.getValues(() => {
        const values = this.props.form.getFieldsValue();
        values.latitude = this.state.address.latitude;
        values.longitude = this.state.address.longitude;
        values.metadata = { status: values.status };
        return values;
      });
  }

  onReset = () => {
    const { onReset } = this.props;
    if (onReset) this.props.onReset(values);
  };

  handleStatusChange = (value) => {
    this.state.status = value;
  };

  setAddressValues = (address) => {
    this.setState({
      address: {
        latitude: address.latitude,
        longitude: address.longitude,
      },
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { editing } = this.props;

    return (
      <Form onSubmit={this.handleSubmit}>
        <ClosedButton onClick={this.props.onClose}>
          <i className="fa fa-times" />
        </ClosedButton>
        <FormItem
          label={
            <span>
              Zone Name &nbsp;
              <Tooltip title="What would you like to call the driver zone?">
                <Icon type="question-circle-o" />
              </Tooltip>
            </span>
          }
        >
          {getFieldDecorator('name', {
            rules: [{ required: true, message: 'Please enter a zone name', whitespace: true }],
          })(<Input placeholder="E.g Zone 1" />)}
        </FormItem>

        <FormItem label="Segment" name="segment" hasFeedback>
          {getFieldDecorator('segment', {
            rules: [
              {
                required: true,
              },
            ],
          })(
            <Select placeholder="Select a segment">
              <Option value={Segment.Fixter_UK}>United Kingdom 🇬🇧</Option>
              <Option value={Segment.Fixter_FR}>France 🇫🇷</Option>
            </Select>
          )}
        </FormItem>

        {!editing && (
          <FormItem label="Center zone on address:">
            {getFieldDecorator('postcode', {
              rules: [{ required: true, message: 'Please select a postcode' }],
            })(
              <div>
                <AddressSelectorWithGooglePlaces
                  countryRule={['uk', 'fr']}
                  apiKey={`${config.gMaps.apiKey}`}
                  onAddressSelected={this.setAddressValues}
                />
              </div>
            )}
          </FormItem>
        )}

        <FormItem label="Status">
          {getFieldDecorator('status', {
            rules: [{ required: true, message: 'Please select a status.' }],
          })(
            <Select onChange={this.handleStatusChange} placeholder="Select a status">
              <Option key="ACTIVE" value="ACTIVE">
                Active
              </Option>
              <Option key="SUSPENDED" value="SUSPENDED">
                Suspended
              </Option>
            </Select>
          )}
        </FormItem>

        {!editing && (
          <FormFooter>
            <Row type="flex" justify="end">
              <Col span={8}>
                <If condition={this.props.onReset}>
                  <Button type="simple" htmlType="button" onClick={this.props.onReset}>
                    Reset
                  </Button>
                </If>
              </Col>
              <Col span={6}>
                <Button type="primary" htmlType="submit" loading={this.props.isLoading}>
                  Save
                </Button>
              </Col>
            </Row>
          </FormFooter>
        )}
      </Form>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    const { formState = props.data || {} } = props;
    return {
      name: Form.createFormField({
        value: formState.name,
      }),
      territoryId: Form.createFormField({
        value: formState.territoryId,
      }),
      status: Form.createFormField({
        value: formState.status,
      }),
      segment: Form.createFormField({
        value: formState.segment,
      }),
    };
  },
})(ZoneEditor);
